'use client'

import React, { createContext, useContext } from 'react'
import { PageContext } from '../../../../types/IPage'
import { EnvTypes } from '../../../../types/envTypes'

export const pageReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'SET_LANDING_CONTENT_DATA':
      return {
        ...state,
        landingContentData: action.payload
      }

    case 'SET_LABELS':
      return {
        ...state,
        labelsData: action.payload
      }

    case 'SET_THEME':
      return {
        ...state,
        theme: action.payload
      }

    case 'SET_FLOATING_LOGOS_VISIBLE':
      return {
        ...state,
        floatingLogosVisible: action.payload
      }

    default:
      return { ...state }
  }
}

export const initialState = {
  state: {
    landingContentData: {},
    getEnvConfig: {},
    locales: {},
    settings: {},
    labelsData: {},
    theme: 'transparent',
    floatingLogosVisible: false
  
  },
  dispatch: () => null
}

type IStateContext = {
  state: {
    landingContentData: PageContext['landingContentData']
    getEnvConfig: EnvTypes
    locales: any
    labelsData: {
      Breadcrumb: { [key: string]: string }
      FAQPanel: { [key: string]: string }
      TasksOverview: { [key: string]: string }
      LatestUpdatePanel: { [key: string]: string }
      Onboarding: { [key: string]: string }
      UpdateInfocard: { [key: string]: string }
      RecommendedService: { [key: string]: string }
      Showkit: { [key: string]: string }
      Navbar: { [key: string]: string }
      Footer: { [key: string]: string }
      RightsidePanel: { [key: string]: string }
      RelatedTasksModule: { [key: string]: string }
      Timeline: { [key: string]: string }
      Task: { [key: string]: string }
      ContactCard: { [key: string]: string }
      StepByStepModule: { [key: string]: string }
      MedalistCategories: { [key: string]: string }
    } | null
    theme: 'black' | 'white' | 'transparent'
    floatingLogosVisible: boolean
    settings: Record<string, unknown> | null
  }
  dispatch: React.Dispatch<{
    type:
    | 'SET_LANDING_CONTENT_DATA'
    | 'SET_LABELS'
    | 'SET_THEME'
    | 'SET_FLOATING_LOGOS_VISIBLE'
    payload: any
  }>
}

// @ts-expect-error --> Explanation missing here
export const StateContext = createContext<IStateContext>(initialState)

export const usePageContext = () => useContext(StateContext)

export default usePageContext
